import React, { useContext as useContextCore } from 'react'
import { queries } from './graphql'
import { useDocument } from '@ztechapps/common.hook'
import { useParams } from 'react-router-dom'
import type { Blog } from '@ztechapps/common.contract'
import { PublicationStatusEnum } from '@ztechapps/common.contract'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }) => {
  const params = useParams()
  const { _id } = params ?? {}

  const documentResult = useDocument<Blog>({
    ...queries.singleConfig,
    filter: { _id, status: PublicationStatusEnum.Active },
  })

  return <CoreProvider value={{ ...props, ...documentResult }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
